var map = {
	"./24px.svg": "./src/assets/24px.svg",
	"./Available.svg": "./src/assets/Available.svg",
	"./Charging.svg": "./src/assets/Charging.svg",
	"./Close.svg": "./src/assets/Close.svg",
	"./Discharging.svg": "./src/assets/Discharging.svg",
	"./Error.svg": "./src/assets/Error.svg",
	"./Group 107 (1).svg": "./src/assets/Group 107 (1).svg",
	"./Group 4601.svg": "./src/assets/Group 4601.svg",
	"./Group 4841 (2).svg": "./src/assets/Group 4841 (2).svg",
	"./Group 4841.svg": "./src/assets/Group 4841.svg",
	"./Group 5498.svg": "./src/assets/Group 5498.svg",
	"./Group_5498.svg": "./src/assets/Group_5498.svg",
	"./Icon awesome-chart-bar.svg": "./src/assets/Icon awesome-chart-bar.svg",
	"./Icon ionic-md-settings.svg": "./src/assets/Icon ionic-md-settings.svg",
	"./Icon material-account-box.svg": "./src/assets/Icon material-account-box.svg",
	"./Icon material-live-help.svg": "./src/assets/Icon material-live-help.svg",
	"./Icon material-supervisor-account.svg": "./src/assets/Icon material-supervisor-account.svg",
	"./Icon metro-search.svg": "./src/assets/Icon metro-search.svg",
	"./Offline.svg": "./src/assets/Offline.svg",
	"./On Route.svg": "./src/assets/On Route.svg",
	"./Plugged.svg": "./src/assets/Plugged.svg",
	"./Vector (2).svg": "./src/assets/Vector (2).svg",
	"./account.svg": "./src/assets/account.svg",
	"./alert.svg": "./src/assets/alert.svg",
	"./arrow.svg": "./src/assets/arrow.svg",
	"./arrowBottom.svg": "./src/assets/arrowBottom.svg",
	"./available.svg": "./src/assets/available.svg",
	"./batteryCell.svg": "./src/assets/batteryCell.svg",
	"./batteryCharge.svg": "./src/assets/batteryCharge.svg",
	"./batteryError.svg": "./src/assets/batteryError.svg",
	"./batteryPlugged.svg": "./src/assets/batteryPlugged.svg",
	"./batterySoc.svg": "./src/assets/batterySoc.svg",
	"./btn smallest (2).svg": "./src/assets/btn smallest (2).svg",
	"./busError.svg": "./src/assets/busError.svg",
	"./calendar.svg": "./src/assets/calendar.svg",
	"./carParkingAvailable.svg": "./src/assets/carParkingAvailable.svg",
	"./charged.svg": "./src/assets/charged.svg",
	"./charging.svg": "./src/assets/charging.svg",
	"./connected1.svg": "./src/assets/connected1.svg",
	"./discharging.svg": "./src/assets/discharging.svg",
	"./done.svg": "./src/assets/done.svg",
	"./down.svg": "./src/assets/down.svg",
	"./error.svg": "./src/assets/error.svg",
	"./ev_error.svg": "./src/assets/ev_error.svg",
	"./ev_evse_error.svg": "./src/assets/ev_evse_error.svg",
	"./evse_error.svg": "./src/assets/evse_error.svg",
	"./ic_close_circle.svg": "./src/assets/ic_close_circle.svg",
	"./ic_directions_bus_48px.svg": "./src/assets/ic_directions_bus_48px.svg",
	"./ic_ev_station_48px.svg": "./src/assets/ic_ev_station_48px.svg",
	"./ic_event_note_48px.svg": "./src/assets/ic_event_note_48px.svg",
	"./ic_insert_link_48px.svg": "./src/assets/ic_insert_link_48px.svg",
	"./ic_menu_24px.svg": "./src/assets/ic_menu_24px.svg",
	"./ic_place.svg": "./src/assets/ic_place.svg",
	"./ic_report.svg": "./src/assets/ic_report.svg",
	"./key.svg": "./src/assets/key.svg",
	"./link_black.svg": "./src/assets/link_black.svg",
	"./offline.svg": "./src/assets/offline.svg",
	"./plugged.svg": "./src/assets/plugged.svg",
	"./pluggedError.svg": "./src/assets/pluggedError.svg",
	"./portError.svg": "./src/assets/portError.svg",
	"./search.svg": "./src/assets/search.svg",
	"./sortAscending_down.svg": "./src/assets/sortAscending_down.svg",
	"./sortAscending_up.svg": "./src/assets/sortAscending_up.svg",
	"./time.svg": "./src/assets/time.svg",
	"./undefined.svg": "./src/assets/undefined.svg",
	"./unplugged.svg": "./src/assets/unplugged.svg",
	"./unplugged1.svg": "./src/assets/unplugged1.svg",
	"./up.svg": "./src/assets/up.svg",
	"./user.svg": "./src/assets/user.svg",
	"./v2g.svg": "./src/assets/v2g.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.svg$";